import LicenseRecord from './license-record'
import QRCode from 'qrcode'
///courier/license/cert/queryPage

const Card = {
  props:['data'],
  data(){
    return {
      qrcode:''
    }
  },
  created(){
    this.$watch('data' , function(nv){
      if(nv){
        this.updateQrcode()
      }
    },{immediate:true})
  },
  methods:{
    updateQrcode(){
      if( !this.data.certVO ){
        this.qrcode = null
      }else{
        let value = this.data.certVO.licenseNo
        QRCode.toString(value, {
          margin: 0,
          width: 100,
          height: 100,
          color: {
            dark: (this.data.certVO.color+'ff') || '#000000ff'
          }
        }, (err, data) => {
          if (err) throw err
          this.qrcode = 'data:image/svg+xml;base64,' + btoa(data)
        })
      }
      
    },
    handleClick(){
      if( this.data.examState == 5 ){
        this.$dialog({
          title:'证照信息',
          paddingless: true,
          onOk:()=>{
            
          },
          render: (h) => {
            return <sl-img src={this.data.certVO.imgPath} public={true} />
          }
        })
      }
      
    }
  },
  render(){
    let data = this.data || {}
    let cert = data.certVO || {}
    return <div style="border-radius:3px;box-shadow:rgba(0, 0, 0, 0.3) 0px 2px 4px;margin:16px;width:380px;margin-bottom:16px;" on-click={this.handleClick}>
      <div class="flex" style="border-bottom:1px solid rgba(0,0,0,.1);padding:10px 16px;font-size:14px;color:#333;">
        <div>{data.name}</div>
        <div style="flex:none;">{data.examStateText}<Icon type="ios-arrow-forward" style="margin-left:8px;" /></div>
      </div>
      <div class="flex" style="padding:16px;justify-content: start;height:100px;box-sizing: initial;">
        {
          this.qrcode ? <img src={this.qrcode} /> : null
        }
        {
          data.examState == 5 ? <div style="font-size:14px;margin-left:16px;display:flex;just-content:center;flex-direction:column;">
            <div>总分：{data.scoreTotal}</div>
            <div>已扣：{cert.actScore}</div>
          </div> : null
        }
      </div>
      <div style="padding:0px 16px 8px 16px;font-size:12px;color:#999">{data.organizationName}</div>
    </div>
  }
}

const LicenseView = {

}
export default {
  props:['id'],
  data(){
    return {
      loading:false,
      data:[]
    }
  },
  created(){
    this.$watch('id' , function(nv){
      if(nv){
        this.query()
      }else{
        this.data = null
      }
    },{immediate:true})
    
  },
  methods: {
    query(){
      this.loading = true
      this.$request.courierLicenses({ search:this.id , pageSize:100 , pageNum:1}).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data.list||[] , {'examState':'examState'})
      })
    },

  },
  render(){
    if( !this.data || this.data.length == 0 ){
      return <div style="font-size: 14px; color: rgba(0, 0, 0, 0.45); padding: 45px; text-align: center;"><Icon type="ios-basket-outline" style="font-size: 48px; opacity: 0.3; margin-bottom:16px;" /><p>还未申领证照</p></div>
    }
    return <div>
      {
        this.data.map( i => <Card data={i} />)
      }
      
    </div>
  }
}

/*
<div>
        
        <div style="margin:1em 0;font-size:14px;">当前分值：{this.data.score}</div>
      </div>
      <LicenseRecord id={this.id} />
*/